import React, { Fragment } from "react";
import { COLORS } from '../../styles/colors'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonContent from './../ButtonContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MonthPicker from './../MonthPicker';
import { STRIPE_HELP_VIDEO_LINK, STRIPE_USER } from '../../constants';
import YouTubeVideoPreview from './../YouVideoPreview'
import { Tooltip, IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import DownloadCSV from './../DownloadCSV'
import { faSearch, faUser, faAddressBook  } from '@fortawesome/free-solid-svg-icons'
import Modal from '@material-ui/core/Modal';
import ModalHeading from './../ModalHeading';
import _ from 'lodash';
import moment from 'moment';


const readMoreLimit = 2;

const ClientTable = ({ trainerList, isFullList, toggleFullList }) => {
  
  let totalClients = 0;
  for(let i = 0; i < trainerList.length; i++) {
    totalClients = totalClients + trainerList[i].clients
  }

  return (
   
      <table className="dashboard-table">
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>Display Name</th>
          <th style={{ textAlign: 'center' }}>Clients</th>
        </tr>
      </thead>

     

      {trainerList && trainerList.map((trainer, index) => {
        if(index > readMoreLimit && !isFullList) {
          return;
        }
        return (<tr key={index}>
          <td>{trainer.displayName}</td>
          <td>{trainer.clients}</td>
          </tr>);
      })
      }

        <tr>
          <td colSpan={2} style={{
            textAlign: 'right'
          }}><a onClick={() => {
            toggleFullList()
          }} style={{
            cursor: 'pointer'
          }}>{ isFullList ? 'Hide Full List' : 'See Full List' } </a></td>
        </tr>

       <tr style={{
          background: COLORS.orange,
          color: COLORS.white
        }}>
          <td style={{ textAlign: 'center' }}>Total</td>
          <td>{totalClients}</td>
        </tr>

        

      
      </table>
   
  )
}

const RangeListTable = ({ item }) => {

  return (
    <table className="dashboard-table">
      <thead>
        <tr>
          <th></th>
          <th style={{ textAlign: 'center' }}>Total</th>
        </tr>
      </thead>
      <tbody>
      <tr>
          <td style={{width: '56%'}}>Trainer Added</td>
          <td>{item.brands}</td>
        </tr>
        <tr>
          <td>Clients Added</td>
          <td>{item.clients}</td>
        </tr>
        <tr style={{
          background: COLORS.orange,
          color: COLORS.white
        }}>
          <td>Total</td>
          <td>{ item.clients + item.brands}</td>
        </tr>
        
      </tbody>
    </table>
  )
}

const MonthlyListTable = ({ item }) => {
  const totalTrainer = item.totalTrainer;
  const parqUsed = item.parq.used;
  const actionUsed = item.actions.used;
  const bodyMatrixUsed = item.bodyMatrix.used;
  const totalUsed = parqUsed + actionUsed + bodyMatrixUsed;
  const avrParqUsed =  totalTrainer !== 0 ? Number(parqUsed/totalTrainer).toFixed(2) * 100 : 0;
  const avrActionUsed = totalTrainer !== 0 ? Number(actionUsed/totalTrainer).toFixed(2) * 100 : 0;
  const avrBodyMatrixUsed = totalTrainer !== 0 ? Number(bodyMatrixUsed/totalTrainer).toFixed(2) * 100 : 0;
  const totalAvgUsed = avrParqUsed + avrActionUsed + avrBodyMatrixUsed;
  return (
    <table className="dashboard-table">
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>Feature</th>
          <th style={{ textAlign: 'center' }}> Used </th>
          <th style={{ textAlign: 'center' }}> Trainer </th>
          <th style={{ textAlign: 'center' }}> Average % </th>
        </tr>
      </thead>
      <tbody>
      <tr>
          <td style={{width: '56%'}}>Par-q</td>
          <td>{parqUsed}</td>
          <td>{totalTrainer}</td>
          <td>{avrParqUsed}</td>
        </tr>
        <tr>
          <td>Committed Action Plan Feature</td>
          <td>{actionUsed}</td>
          <td>{totalTrainer}</td>
          <td>{avrActionUsed}</td>
        </tr>

        <tr>
          <td>Functional Strength</td>
          <td>{bodyMatrixUsed}</td>
          <td>{totalTrainer}</td>
          <td>{avrBodyMatrixUsed}</td>
        </tr>

        <tr style={{
          background: COLORS.orange,
          color: COLORS.white
        }}>
          <td>Total</td>
          <td>{totalUsed}</td>
          <td>{totalTrainer*3}</td>
          <td>{totalTrainer !== 0 ? Number(totalUsed/(totalTrainer*3) * 100).toFixed(2)  : 0}</td>
        </tr>
        
      </tbody>
    </table>
  )
}

const ActiveList = ({ title, subtitle, value, isTrainer }) => {
  return (
    <div style={{
      textAlign: 'center',
      background: COLORS.greyFour,
      border: '1px solid ' + COLORS.grey,
      borderRadius: 10,
      margin: 5,
      display: 'flex',
      flexDirection: 'column',
      height: 175,
      justifyContent: 'space-between',
      padding: 10
    }}>
      <div>
        <FontAwesomeIcon
          icon={isTrainer? faUser : faAddressBook}
          style={{
            color: COLORS.lightGrey,
            fontSize: 45
          }}
        />
      </div>
      <div style={{
        color: COLORS.grey,
        fontSize: 20
      }}>{title}</div>
      {
        subtitle ? (
          <div>{subtitle}</div>
        ) : null
      }
      <div style={{ fontSize: 20 }}>{value}</div>
    </div>
  )
}



class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      links: [],
      startDate: new Date(moment().startOf('month').format('YYYY-MM-DD hh:mm')),
      endDate:  new Date(moment().endOf('month').format('YYYY-MM-DD hh:mm')),
      monthDate: new Date(moment().startOf('month').format('YYYY-MM-DD hh:mm')),
      trainerMonthDate: new Date(moment().startOf('month').format('YYYY-MM-DD hh:mm')),
      totalTrainer: 0,
      totalClients: 0,
      trainerList: [],
      isOpenCompleteList: false,
      rangeItem: {
         brands: 0,
         clients: 0
      },
      isFullList: false,
      monthlyItem: {
        totalTrainer: 0,
        parq: {
          used: 0
        },
        actions: {
          used: 0
        },
        bodyMatrix: {
          used: 0
        }
      }
    }
    this.trainerSelectMonthPicker = React.createRef();
    this.addStatStartDatePicker = React.createRef();
    this.addStatEndDatePicker = React.createRef();
    this.monthlySelectMonthPicker = React.createRef();
  }
  

  componentDidMount() {
    this.getActiveList();
    this.getActiveListRange();
    this.getMonthlyList();
  }

  getActiveList() {
    this.props.fetchActiveList({ params:
      {startDate: this.state.trainerMonthDate
    }}).then((res) => {
      let totalClients = 0;
      const { brands } = res;
      let trainerList = [];
      for (let i = 0; i < brands.length; i++) {
        const brand = brands[i];
        totalClients = totalClients + brand.clients.length;
        trainerList.push({
          displayName: brand.displayName,
          clients: brand.clients.length
        })
      }
      this.setState({
        totalTrainer: brands.length,
        totalClients: totalClients,
        trainerList:  _.orderBy(trainerList, ['clients'],['desc'])
      })
    })
  }

  getActiveListRange() {
    this.props.fetchActiveListRange({ params: { startDate: this.state.startDate, endDate: this.state.endDate } }).then((res) => {
      const { brands, clients } = res;
      this.setState({
        rangeItem: {
          brands: brands,
          clients:  clients
        }
      })
    })
  }

  getMonthlyList() {
    this.props.fetchMonthlyList({ params: { startDate: this.state.monthDate } }).then((res) => {
      const { parq, actions, bodyMatrix, trainer  } = res;
      this.setState({
        monthlyItem: {
          parq: parq,
          actions:  actions,
          bodyMatrix: bodyMatrix,
          totalTrainer: trainer
        }
      })
    })
  }

  render() {
    const { dashboard, totalClients, totalTrainer, trainerList, isOpenCompleteList, monthlyItem, rangeItem, isFullList } = this.state;
    const { user } = this.props;
 
    return (
      <div>
        <h1>NCEP Stats</h1>
        

<Fragment>

<div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '25%' }}>
              <ActiveList
                title='Trainers'
                value={totalTrainer}
                isTrainer = {true}
              />
            </div>
            <div style={{ width: '25%' }}>
              <ActiveList
                title='Clients'
                value={totalClients}
              />
            </div>
          </div>
        </div>
        <br></br>
        <hr></hr>
                <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '90px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <h3>Trainers List </h3>

                  
                   
                  </div>
                  
                 
  
                  
                </div>

                <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '90px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <p>Select Month </p>
                    <MonthPicker
                      selected={this.state.trainerMonthDate}
                      onChange={(date) => {
                        this.setState({
                          trainerMonthDate: date
                        }, () => {
                          this.getActiveList()
                        })
                      }}
                      isSecPicker = {true}
                      isDayPicker = {false}
                      ref={this.trainerSelectMonthPicker}
                    />
                  </div>

                  
                 
                </div>
              </Fragment>

        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between'
        }}>
         
          <div style={{ width: '98%' }}>
            <ClientTable
              trainerList={trainerList}
              isFullList = {isFullList}
              toggleFullList = {
                () => {
                  this.setState({
                    isFullList: !isFullList
                  })
                }
              }
            />
            { trainerList.length  > readMoreLimit + 1 &&
            <div style={{
              display: 'initial',
              float: 'right',
              marginTop: 10
            }}>
          
            </div>
            }


            { isOpenCompleteList && 
             <Modal
                className="modal show"
                open={isOpenCompleteList}
                onClose={() => this.setState({isOpenCompleteList:false})}>
                <div className="modalBody modal-content" style={{width:550, maxHeight: '90%', overflow: 'auto', overflowX: 'hidden'}}>
                   <ModalHeading
                      text={(
                   <div>
                     <FontAwesomeIcon icon={faUser}
                       style={{marginRight: 5, color: COLORS.orange}}/>
                     <span>Trainers List</span>
                   </div>
   
                 )}
                      closeModal={() => this.setState({isOpenCompleteList : false})}/>
                    <div className="modalContent">
                 <ClientTable trainerList={trainerList} isFullList = {true}  />
                    </div>
             </div>
           </Modal>
           }
          </div>
        </div>
        <br></br>
        <hr></hr>
        <Fragment>

        <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '60px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <h3>NCEP Added Stats </h3>
                   
                  </div>
                  </div>

                <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '90px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <p>Start Date </p>
                    <MonthPicker
                      selected={this.state.startDate}
                      onChange={(date) => {
                        this.setState({
                          startDate: date
                        })
                      }}
                      isDayPicker = {true}
                      ref={this.addStatStartDatePicker}
                    />
                  </div>

                  <div style={{
                    display: 'initial',
                    float: 'left',
                    marginLeft: 10,
                  }}>
                  <p>End Date </p>
                    <MonthPicker
                      selected={this.state.endDate}
                      isEndDatePicker = {true}
                      onChange={(date) => {
                        this.setState({
                          endDate: date
                        })
                      }}
                      isDayPicker = {true}
                      ref={this.addStatEndDatePicker}
                    />

                    <FontAwesomeIcon size={ "1x" } icon={faSearch} title={'Search'}
								       style={{ marginLeft: 10, color: COLORS.orange }} onClick= {
                        () => {
                          this.getActiveListRange()
                        }
                       } />
                  </div>
                 
                </div>
  
                <div style={{
                  display: 'flex',
                  width: '100%',
                 justifyContent: 'space-between'
                }}>
                   <div style={{ width: '98%' }}>
                   <RangeListTable
                       item={rangeItem}
                    />
                    
               </div>
              </div>
        </Fragment>

        <br></br>
        <hr></hr>
        <Fragment>

        <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '60px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <h3>NCEP Monthly Stats </h3>
                   
                  </div>
                  </div>

                <div style={{
                  display: 'flow-root',
                  padding: 20,
                  paddingLeft: 0,
                  width: '100%',
                  height: '90px'
                }}>
                  <div style={{
                    display: 'initial',
                    float: 'left'
                  }}>
                  <p>Select Month </p>
                    <MonthPicker
                      selected={this.state.monthDate}
                      onChange={(date) => {
                        this.setState({
                          monthDate: date
                        }, () => {
                          this.getMonthlyList()
                        })
                      }}
                      isSecPicker = {true}
                      isDayPicker = {false}
                      ref={this.monthlySelectMonthPicker}
                    />
                  </div>

                  
                 
                </div>
  
                <div style={{
                  display: 'flex',
                  width: '100%',
                 justifyContent: 'space-between'
                }}>
                   <div style={{ width: '98%' }}>
                   <MonthlyListTable
                       item={monthlyItem}
                    />
               </div>
              </div>
        </Fragment>
        
      
      </div>
    )
  }
}
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboards/Stat.js